<ds-card>
  <div class="d-flex flex-column my-2 p-4 p-md-6 w-100">
    <img src="assets/images/agents.webp" alt="agents" class="mx-auto agents" />

    <h3 class="semi-bold mx-auto mt-6 d-md-none">Searching for a Travel Expert...</h3>
    <h2 class="d-none d-md-flex semi-bold mx-auto mt-8">Searching for a Travel Expert...</h2>
  </div>
</ds-card>
